<template>

    <section id="new_ref_fourth_step" class="flex friend_wrap_page" v-if="baseRef">

        <titlePage>
            <template slot="titleBody">
                <div class="hero-head has-text-centered" >
                    <h1 class="title has-text-weight-light is-size-1 has-text-weight-light">{{ getRefName(baseRef) }}</h1>
                    <h2 class="associated_ref_name">
                        {{ $t('modules.friends.friendsWrap.recruiter') }} : <span>{{ friendRef.recruiter_name }}</span>
                    </h2>

                    <div class="friend_ref_action">
                        <div class="locale_switcher_container">
                            <LocaleSwitcher />
                        </div>


                        <div v-if="!friendRefCompleted">
                            <button class="button is-info is-outlined"
                            :disabled="formHasError"
                            @click="saveFriendRef">
                                {{ $t('modules.friends.friendsWrap.saveRefButton') }}
                            </button>
                        </div>
                        <div v-else>
                            <div class="sight_ref_friend_completed_notice">
                                <iconWarning />
                                <p>
                                    {{ $t('modules.friends.friendsWrap.refNotEditable') }}
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
            </template>
        </titlePage>

        <div class="container">

            <div class="friend_tabs">
                <div class="score_tab" :class="{active: (activeTab == 'scores')}" @click="activeTab = 'scores'">
                    {{ $t('modules.friends.friendsWrap.scoresTab') }}
                </div>
                <div class="coeffs_tab" :class="{active: (activeTab == 'coeffs'), 'has-errors': formHasError}" @click="activeTab = 'coeffs'">
                    {{ $t('modules.friends.friendsWrap.coeffsTab') }}
                </div>
            </div>
        </div>

        <div class="friend_tabs_content_container flex flex_content" >
            <div class="container">
                <transition :name="stepAnim">
                    <component :is="currentTabComponent" @dataChange="handleErrors" ></component>
                </transition>
            </div>
        </div>

        <FriendHelpModal />

    </section>
</template>

<script>
import titlePage from "@/components/layouts/titlePage"
import FriendScores from "./friendScores"
import FriendCoeffs from "./friendCoeffs"
import FriendHelpModal from "./friendHelpModal"

export default {
    name: 'FriendWrap',
    components: {
        titlePage,
        FriendScores,
        FriendCoeffs,
        FriendHelpModal
    },
    data(){
        return {
            activeTab: 'scores',
            formHasError: false
        }
    },
    created(){
        this.$store.dispatch('FriendStore/getFriendRef', this.$store.state.FriendStore.friend_ref_id)
    },
    computed: {
        friendRef(){
            return this.$store.state.FriendStore.friendRef
        },
        baseRef(){
            return this.friendRef.sight_ref
        },
        associatedRef(){
            return this.friendRef.sight_ref.associated_ref
        },
        currentTabComponent(){
            if(this.activeTab == 'scores'){
                return 'FriendScores'
            }else{
                return 'FriendCoeffs'
            }
        },
        stepAnim(){
            if(this.activeTab == 'scores'){
                return 'friend-tab-slide-left'
            }else{
                return 'friend-tab-slide-right'
            }

        },
        friendRefCompleted(){
            return this.$store.state.FriendStore.friendRef.completed
        }
    },
    methods: {
        getRefName(refItem){
            if (refItem.ref_type == 'saven'){
                return this.$i18n.t("refs.jobs." + refItem.slug)
            }else{
                return refItem.name
            }
        },
        saveFriendRef(){
            if(!this.formHasError){
                this.$store.dispatch('FriendStore/saveFriendRef', this.friendRef).then(resp => {
                    this.refSaveNotif = true
                }).catch(err => {
                    console.log('save_error')
                })
            }
        },
        handleErrors(isValid){
            this.formHasError = !isValid
        }
    }
  }

</script>

<style lang="scss" >
    .friend_tabs{
        display: flex;
        justify-content: center;
        align-items: center;
        div{
            cursor: pointer;
            user-select: none;
            font-size: 1.2rem;
            padding: 12px 12px;
            border-bottom: 3px solid $grey-lighter;
            &.active{
                border-color: $info;
            }
            &.has-errors{
                color: $danger;
                border-color: $danger;
            }
        }
    }
    .friend_tabs_content_container{
        background-color: $white;
        height: 90vh;
        padding: 30px 0;
    }
    .sight_ref_friend_completed_notice{
        padding: 12px;
        background: $white-ter;
        width: 500px;
        margin: 30px auto 0;
        display: flex;
        align-items: center;

        svg{
            fill: $info;
            width: 50px;
            margin-right: 12px;
        }
        p{
            text-align: left;
        }
    }
    .friend_ref_action{
        margin-top: 25px;
        max-width: 300px;
        margin-right: auto;
        margin-left: auto;
        .locale_switcher_container{
            margin-bottom: 20px;
        }
    }
    .friend_wrap_page{
        .hero-body{
            padding-bottom: 20px;
        }
    }
    .locale_switcher_container{
        margin-bottom: 20px;
    }
</style>
